(() => {
  'use strict';
  const source = document.querySelector('[data-fultons-mint-samples]');
  if (!source) return;
  let data;
  try { data = JSON.parse(source.textContent); } catch { return; }
  const productIds = ['15883752833407', '15883753062783', '15883753980287', '15883754307967'];
  const samples = data.samples || [];
  const labels = data.labels || {};
  const make = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const identify = item => samples.find(sample => sample.thumbnail === item.thumbnail && sample.label === item.label);
  const describe = sample => [sample.family, sample.label, sample.code].join(' · ');
  let sequence = 0;
  function picturePicker(parent, label, change, signal) {
    const uid = 'MintSample-' + (++sequence);
    const wrap = make('div', '', 'fsd-field fsd-picker fms-picker');
    const heading = make('label', label);
    const trigger = make('button', '', 'fsd-trigger');
    trigger.type = 'button';
    trigger.id = uid;
    heading.htmlFor = uid;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', uid + '-panel');
    const thumb = make('span', '', 'fsd-thumb');
    const selectedLabel = make('span');
    trigger.append(thumb, selectedLabel, make('span', '⌄', 'fsd-arrow'));
    const panel = make('div', '', 'fms-panel');
    panel.id = uid + '-panel';
    panel.hidden = true;
    const searchLabel = make('label', labels.search);
    const search = make('input');
    search.type = 'search';
    search.id = uid + '-search';
    searchLabel.htmlFor = search.id;
    const status = make('p', '', 'fms-status');
    status.setAttribute('role', 'status');
    const grid = make('div', '', 'fms-grid');
    const close = make('button', labels.close, 'fms-close');
    close.type = 'button';
    panel.append(searchLabel, search, status, grid, close);
    wrap.append(heading, trigger, panel);
    parent.append(wrap);
    let items = [], value = '';
    const image = (sample, fallback) => {
      if (!sample) return make('span', labels.inStore, 'fsd-no-image');
      const img = make('img');
      img.src = sample.asset;
      img.alt = fallback || describe(sample);
      img.width = sample.width;
      img.height = sample.height;
      img.loading = 'lazy';
      return img;
    };
    function shut(focus = false) {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (focus) trigger.focus({ preventScroll: true });
    }
    wrap._closePicker = shut;
    function view(sample, opener) {
      const dialog = make('dialog', '', 'fms-original');
      const title = make('h2', describe(sample));
      title.id = uid + '-original-title';
      dialog.setAttribute('aria-labelledby', title.id);
      const dismiss = make('button', labels.close, 'fms-close');
      dismiss.type = 'button';
      const img = image(sample);
      img.loading = 'eager';
      img.style.width = sample.width + 'px';
      const note = make('p', labels.originalNote);
      const size = make('p', sample.width + ' × ' + sample.height + ' px');
      dialog.append(dismiss, title, img, note, size);
      wrap.append(dialog);
      dismiss.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { dialog.remove(); if (opener.isConnected) opener.focus({ preventScroll: true }); }, { once: true });
      signal?.addEventListener('abort', () => dialog.remove(), { once: true });
      dialog.showModal();
      dismiss.focus();
    }
    function sync() {
      const selected = items.find(item => item.value === value);
      const sample = selected && identify(selected);
      thumb.replaceChildren(image(sample));
      selectedLabel.textContent = sample ? describe(sample) : selected?.label || '';
    }
    function render() {
      const query = search.value.trim().toLocaleLowerCase();
      const visible = items.filter(item => {
        const sample = identify(item);
        return (sample ? describe(sample) : item.label).toLocaleLowerCase().includes(query);
      });
      status.textContent = visible.length ? labels.results.replace('[count]', String(visible.length)) : labels.noMatches;
      grid.replaceChildren(...visible.map(item => {
        const sample = identify(item);
        const card = make('div', '', 'fms-card');
        const choose = make('button', '', 'fms-choice');
        choose.type = 'button';
        choose.setAttribute('aria-pressed', String(item.value === value));
        if (sample) choose.dataset.sampleId = sample.id;
        choose.append(image(sample), make('span', sample ? describe(sample) : item.label));
        choose.addEventListener('click', () => {
          value = item.value;
          sync();
          shut(true);
          change(value);
        });
        card.append(choose);
        if (sample) {
          const inspect = make('button', labels.viewOriginal, 'fms-inspect');
          inspect.type = 'button';
          inspect.setAttribute('aria-label', labels.viewOriginal + ' · ' + describe(sample));
          inspect.addEventListener('click', () => view(sample, inspect));
          card.append(inspect);
        }
        return card;
      }));
    }
    trigger.addEventListener('click', () => {
      if (!panel.hidden) { shut(); return; }
      parent.querySelectorAll('.fsd-picker,.fms-picker').forEach(other => { if (other !== wrap) other._closePicker?.(); });
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      render();
      search.focus({ preventScroll: true });
    }, { signal });
    search.addEventListener('input', render, { signal });
    close.addEventListener('click', () => shut(true), { signal });
    wrap.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !wrap.querySelector('dialog[open]') && !panel.hidden) {
        event.preventDefault(); event.stopPropagation(); shut(true);
      }
    }, { signal });
    return {
      wrap, trigger,
      set(nextItems, selected) {
        items = nextItems;
        value = selected;
        search.value = '';
        sync();
        if (!panel.hidden) render();
      }
    };
  }
  window.FultonsMintSamples = {
    productIds, picturePicker,
    summary(colour, family) {
      const sample = samples.find(item => item.label === colour && item.family === family);
      return sample ? colour + ' · ' + labels.supplierCode + ' ' + sample.code : colour;
    }
  };
})();
